export default __webpack_public_path__ + "static/LeituraSansTwo-Light-cf4a4c297c9424f3559c81a7289ae137.woff";